module.exports = "/images/ba.svg?e94d45765b5bba2e31db3e714fbbb9a1";